import React, {Component} from 'react';

export default class Contacts extends Component {

    render() {
        return (
            <div className="page">
                <div className="page_contents">
                    <h1>{'Contacts'}</h1>
                    <div className="card">
                        <p>
                            {'Comments or questions? Contact us at '}<a href="mailto:support@deepcontrast.com">{'support@deepcontrast.com'}</a>{` and we'll
                            get back to you as soon as possible.`}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Contacts.js